/* eslint-disable no-use-before-define */
import { useTranslation } from "react-i18next";
import React, { useEffect, useState, useContext } from "react";
import { useLazyQuery, gql,TypedDocumentNode } from "@apollo/client";
import { connectField } from "uniforms";
import { SelectField } from "./SelectField";
import LoginContext from "/imports/client/context/loginContext";
import { SelectFieldProps } from "./SelectField.d";

import Debug from "debug";
const debug = Debug("partners:ui");

interface IPartnerInfo { id: string, name: string, type: string }

export const GET_PARTNERS:TypedDocumentNode<{partners: IPartnerInfo[]}> = gql`
  query getPartnersSelectField(
    $types: [ACCOUNT_TYPE]
    $includeOwnAccount: Boolean
    $includeInactive: Boolean
    $excludeAccounts: [String]
  ) {
    partners: getPartners(
      types: $types
      includeOwnAccount: $includeOwnAccount
      includeInactive: $includeInactive
      excludeAccounts: $excludeAccounts
    ) {
      id
      name
      type
    }
  }
`;

export const PartnerSelectField = ({ loading, label, partners, ...props }) => {
  const { t } = useTranslation();
  return (
    <SelectField
      {...props}
      label={label || t("form.partner")}
      search
      loading={loading}
      options={partners.map(({ id, name }) => ({ value: id, text: name, description: id }))}
    />
  );
};



interface IPartnerSelectFieldLoaderProps extends SelectFieldProps {
  setRefData: () => void,
  options?: {
    partnersList?: IPartnerInfo[];
    includeOwnAccount?: boolean;
    includeInactive?: boolean;
    excludeAccounts?: string[]
    types?: string[];
    /**@deprecated */
    type?: string
  }
}

export const PartnerSelectFieldLoader = ({ options = {}, setRefData, ...props }: IPartnerSelectFieldLoaderProps) => {
  const { accountId } = useContext(LoginContext);
  const { includeOwnAccount, type, types, excludeAccounts, includeInactive = true } = options;
  const [partners, setPartners] = useState<IPartnerInfo[]>([])
  debug("get data for %o", { includeOwnAccount, type, types, excludeAccounts, includeInactive });

  const [getPartners, { loading, error }] = useLazyQuery(GET_PARTNERS, {
    variables: {
      includeInactive,
      ...(includeOwnAccount ? { includeOwnAccount } : undefined),
      ...(excludeAccounts ? { excludeAccounts } : undefined),
      ...(types ? { types } : undefined),
      ...(type ? { types: [type] } : undefined)
    },
    fetchPolicy: "no-cache"
  });

  useEffect(() => {
    const partnersFilteredList = (options.partnersList || []).filter((partner)=> partner?.id !== accountId);
    if (partnersFilteredList.length) {
      setPartners(partnersFilteredList);
    } else {
      getPartners().then(({ data }) => {
        setPartners(data?.partners || [])
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options.partnersList]);
  if (error) debug("error", error);
  return <PartnerSelectField {...{ ...props, partners, loading }} />;
};

export default connectField<IPartnerSelectFieldLoaderProps>(PartnerSelectFieldLoader);
